import { useState } from "react";
import axios from "axios";

const Bookmark = (props) => {
  const {
    apiUrl,
    method = "POST",
    payload = {},
    onSuccess,
    onError,
    defaultImage,
    activeImage,
    loadingImage,
  } = props;

  const [loading, setLoading] = useState(false);
  const [bookmarked, setBookmarked] = useState(false);

  const handleClick = async () => {
    setLoading(true);
    try {
      const response = await axios({
        url: apiUrl,
        method,
        data: payload,
      });

      setBookmarked((prev) => !prev);
      if (onSuccess) onSuccess(response.data);
    } catch (error) {
      if (onError) onError(error);
      console.error("Bookmark API Error:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      onClick={handleClick}
      disabled={loading}
      style={{
        border: "none",
        background: "transparent",
        cursor: "pointer",
      }}
    >
      <img
        src={
          loading
            ? loadingImage || defaultImage
            : bookmarked
            ? activeImage
            : defaultImage
        }
        alt="bookmark"
        style={{ width: "14px", height: "14px" }}
      />
    </button>
  );
};

export default Bookmark;
